"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ElectricityType;
(function (ElectricityType) {
    ElectricityType["europe"] = "europe";
    ElectricityType["usa"] = "usa";
    ElectricityType["china"] = "china";
    ElectricityType["world"] = "world";
    ElectricityType["france"] = "france";
    ElectricityType["uk"] = "uk";
    ElectricityType["ireland"] = "ireland";
    ElectricityType["spain"] = "spain";
    ElectricityType["portugal"] = "portugal";
    ElectricityType["netherlands"] = "netherlands";
    ElectricityType["belgium"] = "belgium";
    ElectricityType["danmark"] = "danmark";
    ElectricityType["germany"] = "germany";
    ElectricityType["poland"] = "poland";
    ElectricityType["italy"] = "italy";
    ElectricityType["turkey"] = "turkey";
    ElectricityType["finland"] = "finland";
    ElectricityType["norway"] = "norway";
    ElectricityType["czechia"] = "czechia";
    ElectricityType["austria"] = "austria";
    ElectricityType["serbia"] = "serbia";
    ElectricityType["slovenia"] = "slovenia";
    ElectricityType["hungary"] = "hungary";
    ElectricityType["slovakia"] = "slovakia";
    ElectricityType["ukraine"] = "ukraine";
    ElectricityType["romania"] = "romania";
    ElectricityType["moldava"] = "moldava";
    ElectricityType["estonia"] = "estonia";
    ElectricityType["latvia"] = "latvia";
    ElectricityType["lithuania"] = "lithuania";
    ElectricityType["peru"] = "peru";
    ElectricityType["bolivia"] = "bolivia";
    ElectricityType["argentina"] = "argentina";
    ElectricityType["uruguay"] = "uruguay";
    ElectricityType["brazil"] = "brazil";
    ElectricityType["australia"] = "australia";
})(ElectricityType = exports.ElectricityType || (exports.ElectricityType = {}));
